import React from 'react';

import { Flex } from '@chakra-ui/react';
// import { List, ListItem, ListItemText } from '@material-ui/core';
import { isSameDay } from 'date-fns';

import { isMobileView } from 'constants/isMobileView';

import { Chip } from 'uiToolkitV1/Chip';
import { TextLabel } from 'uiToolkitV1/Typography';

const isSameRange = (first, second) => {
  const { startDate: fStart, endDate: fEnd } = first;
  const { startDate: sStart, endDate: sEnd } = second;
  if (fStart && sStart && fEnd && sEnd) {
    return isSameDay(fStart, sStart) && isSameDay(fEnd, sEnd);
  }
  return false;
};

const DefinedRanges = ({ ranges, setRange, selectedRange }) => (
  <Flex gap={2} mb="12px !important" direction={isMobileView() && 'column'}>
    {ranges.map((range, idx) => (
      // biome-ignore lint/suspicious/noArrayIndexKey: No explanation provided in original eslint-disable
      <Chip key={idx} variant="outlined" selected={isSameRange(range, selectedRange)} onClick={() => setRange(range)}>
        <TextLabel bold color="text.g2">
          {range.label}
        </TextLabel>
      </Chip>
      // <ListItem button key={idx} onClick={() => setRange(range)}>
      //   <ListItemText
      //     primaryTypographyProps={{
      //       variant: 'body2',
      //       style: {
      //         fontWeight: isSameRange(range, selectedRange) ? 'bold' : 'normal'
      //       }
      //     }}
      //   >
      //     {range.label}
      //   </ListItemText>
      // </ListItem>
    ))}
  </Flex>
);

export default DefinedRanges;
